import { Maybe } from 'graphql/jsutils/Maybe'
import React from 'react'

import { SanityGalleryCollection } from '../../../graphql/gatsby'
import { GalleryItem } from './GalleryItem'
import * as Styled from './styled'

interface GalleryCollectionProps {
  collection: Maybe<SanityGalleryCollection>
}

export const GalleryCollection: React.FC<GalleryCollectionProps> = ({ collection }) => {
  const { title, collection: items } = collection || {}
  return (
    <Styled.GalleryCollectionsContainer>
      <Styled.Subtitle>{title}</Styled.Subtitle>
      <Styled.ItemsLayout>
        {items?.map((item, index) => (
          <GalleryItem key={`${index}:${item?.title}`} galleryItem={item} />
        ))}
      </Styled.ItemsLayout>
    </Styled.GalleryCollectionsContainer>
  )
}
